var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.129,
    height: 18.744,
    viewBox: "0 0 11.129 18.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".phoneSvg{fill:#3553b2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "phoneSvg",
    d: "M35.518,0H27.611A1.611,1.611,0,0,0,26,1.611V17.133a1.611,1.611,0,0,0,1.611,1.611h7.908a1.611,1.611,0,0,0,1.611-1.611V1.611A1.611,1.611,0,0,0,35.518,0Zm-8.64,3.323h9.372v11.26H26.879ZM27.611.879h7.908a.732.732,0,0,1,.732.732v.833H26.879V1.611A.732.732,0,0,1,27.611.879Zm7.908,16.987H27.611a.732.732,0,0,1-.732-.732V15.461h9.372v1.672A.732.732,0,0,1,35.518,17.865Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "phoneSvg",
    cx: 0.879,
    cy: 0.879,
    r: 0.879,
    transform: "translate(30.686 15.802)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "phoneSvg",
    d: "M53.569,9.1h2.306a.439.439,0,1,0,0-.879H53.569a.439.439,0,0,0,0,.879Z",
    transform: "translate(-23.157 -7.016)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6e60ba7c.svg";
export { ForwardRef as ReactComponent };